import IconTemplate from '@components/Icon';
import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    position: relative;
    margin: ${rem(25)} 0 0 0;
    padding: ${rem(15)} 0;
    color: ${({ theme }) => theme.colors.grey};

    @media (min-width: ${breakpoints.sm}px) {
        padding: 0;
        margin: ${rem(40)} 0;
    }
`;

export const Lecturers = styled.div`
    @media (min-width: ${breakpoints.sm}px) {
        width: 75%;
    }
`;

export const DescriptionMoreLink = styled.button`
    background: none;
    padding: 0;
    border: none;
    cursor: pointer;
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.fontSizes.textBase};
    margin-top: ${rem(20)};
`;

export const Description = styled.div`
    padding-top: ${rem(20)};
    line-height: ${rem(28)};
    font-size: ${({ theme }) => theme.fontSizes.h6};

    &.short {
        line-clamp: 5;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
        overflow: hidden;
    }

    &.long {
        line-clamp: unset;
    }
`;
